/*
 * "You may also like" carousel.
 *
 * Same Swiper setup as the Featured Collections section (featured-collections.js),
 * without the tabs. The markup only exists once Dawn's <product-recommendations>
 * has fetched it and swapped it in, so the carousel builds itself on connect
 * rather than on page load. Requires swiper-bundle.min.js, loaded first by
 * the section.
 */
if (!customElements.get('related-products-carousel')) {
  customElements.define(
    'related-products-carousel',
    class RelatedProductsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.swiper) return;

        // The cards' images are deferred (card-product defer_media) and this markup arrives by fetch.
        if (window.deferredMedia) window.deferredMedia.scan(this);

        // Both scripts are deferred, but guard anyway in case the element
        // connects before Swiper has evaluated.
        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.connectedCallback(), { once: true });
          return;
        }

        const container = this.querySelector('.swiper');
        const slideCount = container ? container.querySelectorAll('.swiper-slide').length : 0;
        if (slideCount === 0) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const prevEl = this.querySelector('.featured-collections__arrow--prev');
        const nextEl = this.querySelector('.featured-collections__arrow--next');
        const scrollbarEl = this.querySelector('.featured-collections__scrollbar');

        this.swiper = new Swiper(container, {
          // Below 990px the cards are a fixed 180px wide (section-featured-collections.css).
          slidesPerView: 'auto',
          spaceBetween: 12,
          speed: reduceMotion ? 0 : 500,
          loop: this.dataset.loop === 'true' && slideCount > 2,
          watchOverflow: true,
          grabCursor: true,
          a11y: { enabled: true },
          keyboard: { enabled: true, onlyInViewport: true },
          mousewheel: { forceToAxis: true, releaseOnEdges: true },
          navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
          scrollbar: scrollbarEl ? { el: scrollbarEl, draggable: true } : false,
          breakpoints: {
            750: { slidesPerView: 'auto', spaceBetween: 16 },
            990: { slidesPerView: 4, spaceBetween: 20 },
            1200: { slidesPerView: 5, spaceBetween: 20 },
          },
        });
      }

      disconnectedCallback() {
        if (this.swiper) this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
